import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./mob_menu.module.css";


function MobMenu({ setShowMenu }) {


  const handleClickLink = () => {
    setShowMenu(false);
  }


  return (
    <nav className={styles.container}>
      <NavLink to="/"
        className={({ isActive }) => isActive ? `${styles.buttonLink_active}` : `${styles.buttonLink}`}
        onClick={handleClickLink}
      >Главная
      </NavLink>

      <NavLink to="/catalog"
        className={({ isActive }) => isActive ? `${styles.buttonLink_active}` : `${styles.buttonLink}`}
        onClick={handleClickLink}
      >Каталог
      </NavLink>

      <NavLink to="/about"
        className={({ isActive }) => isActive ? `${styles.buttonLink_active}` : `${styles.buttonLink}`}
        onClick={handleClickLink}
      >О компании
      </NavLink>

      <NavLink to="/contacts"
        className={({ isActive }) => isActive ? `${styles.buttonLink_active}` : `${styles.buttonLink}`}
        onClick={handleClickLink}
      >Контакты
      </NavLink>
    </nav>
  );
}

export default MobMenu;
